import PropTypes from 'prop-types'
import Opiniones from './Opiniones'

import './CalificacionProducto.css'

const MAX_ESTRELLAS = 5

const CalificacionProducto = (props) => {
  const arrayCalificacionPromedio = props.calificacion.map((e) => e.promedioCalificacion)
  const calificacionPromedio = arrayCalificacionPromedio[0]

  return (
    <div className="col mt-4">
      <p className="titulo-detalle">Opiniones del Producto</p>
      <div className="row informacion">
        <div className="col">
          <div className="row">
            <div className="col">
              <p className="puntuacion text-center ml-3">
                Puntuación promedio:
                {[...Array(MAX_ESTRELLAS)].map((_, i) => (
                  <i
                    key={i}
                    className={`fa ${i < calificacionPromedio ? 'fa-star' : 'fa-star-o'} yellow-star ml-1`}
                    aria-hidden="true"
                  ></i>
                ))}
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-12 bordered">
              {props.calificacion.map((e) => (
                <Opiniones
                  key={e.idCalificacion}
                  calificacion={e.calificacionAlItem}
                  comentario={e.comentario}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

CalificacionProducto.propTypes = {
  calificacion: PropTypes.arrayOf(
    PropTypes.shape({
      idCalificacion: PropTypes.number.isRequired,
      promedioCalificacion: PropTypes.number.isRequired,
      calificacionAlItem: PropTypes.number.isRequired,
      comentario: PropTypes.string.isRequired
    })
  ).isRequired
}

export default CalificacionProducto
